// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f729a804","453":"19751446","806":"dbe30f93"}[chunkId] + ".chunk.js";
};